<iframe [src]="trustedSrc()"></iframe>
